//import React from "react";

const TempNotFound = () => {
    return <div>Page not found</div>;
};

export default TempNotFound;
